<template>
    <div class="advanced-filters">
        <button class="advanced-filters__button button button--clear" @click="minimizeFilters">
            <h3 class="filter-heading filter-heading--simple">Avancerad filtrering</h3>
            <span class="icon" :class="{ 'icon--minus': filterStore.showAdvancedFilter, 'icon--plus': !filterStore.showAdvancedFilter }"></span>
        </button>
        <div v-if="filterStore.showAdvancedFilter" class="filter-section">
            <div class="filter-section__filters">
                <DropdownFilter dataKey="navalBattles" placeholder="Välj händelse" title="Deltog i" />
                <IntervalFilter dataKey="suspension" title="Avslut/Avfört ur flottan" />
                <DropdownFilter dataKey="fates" placeholder="Välj typ av avslut" title="Typ av avslut"/>
                <DropdownFilter dataKey="constructionSite" placeholder="Välj byggnadsort" title="Byggnadsort" />
            </div>
        </div>
        <div v-if="filterStore.showAdvancedFilter" class="filter-section">
            <button class="advanced-filters__button advanced-filters__button--sub button button--clear" @click="minimizeConstructionFilters">
                <h3 class="filter-heading filter-heading--simple">Konstruktion</h3>
                <span class="icon" :class="{ 'icon--minus': showConstructionFilters, 'icon--plus': !showConstructionFilters }"></span>
            </button>
            <div v-if="showConstructionFilters" class="filter-section__filters">
                <DropdownFilter dataKey="constructor" placeholder="Välj byggmästare" title="Byggmästare" />
                <!-- <DropdownFilter dataKey="woodType" placeholder="Välj träslag" title="Träslag" /> Temporary -->
                <DropdownFilter dataKey="status" placeholder="Lägesbestämd" title="Lägesbestämd" />
            </div>
        </div>
        <div v-if="filterStore.showAdvancedFilter" class="filter-section__filters">
            <button class="advanced-filters__button advanced-filters__button--sub button button--clear" @click="minimizePropertiesFilters">
                <h3 class="filter-heading filter-heading--simple">Egenskaper</h3>
                <span class="icon" :class="{ 'icon--minus': showPropertiesFilters, 'icon--plus': !showPropertiesFilters }"></span>
            </button>
            <div v-if="showPropertiesFilters" class="filter-section__filters">
                <IntervalFilter dataKey="length" title="Längd" />
                <IntervalFilter dataKey="width" title="Bredd" />
                <IntervalFilter dataKey="numberOfCannons" title="Kanoner" />
                <IntervalFilter dataKey="numberOfSailors" title="Sjöfolk" />
                <IntervalFilter dataKey="numberOfSoldiers" title="Soldater" />
                <IntervalFilter dataKey="crewTotal" title="Total besättning" />
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import { useStore } from "../../stores/store";
import { ref } from 'vue';
import DropdownFilter from '@/components/filter/DropdownFilter.vue';
import IntervalFilter from '@/components/filter/IntervalFilter.vue';
import { useFilterStore } from "../../stores/filterStore";
const filterStore = useFilterStore();
const showConstructionFilters = ref(true);
const showPropertiesFilters = ref(true);

const minimizeFilters = () => {
    filterStore.showAdvancedFilter = !filterStore.showAdvancedFilter;
}

const minimizeConstructionFilters = () => {
    showConstructionFilters.value = !showConstructionFilters.value;
}

const minimizePropertiesFilters = () => {
    showPropertiesFilters.value = !showPropertiesFilters.value;
}

</script>
